export default {
    // Contract
    CONTRACT_READ: { value: 'CONTRACT_READ', version: 'legacy' },
    CONTRACT_WRITE: { value: 'CONTRACT_WRITE', version: 'legacy' },
    ANALYTICS_READ: { value: 'ANALYTICS_READ', version: 'legacy' },
    CONTRACT_UPLOAD: { value: 'CONTRACT_UPLOAD', version: 'legacy' },

    // Views
    VIEWS_READ: { value: 'VIEWS_READ', version: 'legacy' },
    VIEWS_ALL_VIEW: { value: 'VIEWS_ALL_VIEW', version: 'legacy' },

    // Clause Library
    CLAUSE_READ: { value: 'CLAUSE_READ', version: 'legacy' },

    // DigApps
    ADMIN_LOGICAPPS: { value: 'ADMIN_LOGICAPPS', version: '8.1' },
    DIGAPP_READ: { value: 'DIGAPP_READ', version: '7.3' },
    LOGICAPP_RUN: { value: 'LOGICAPP_RUN', version: '7.5' },
    LOGICAPP_READ: { value: 'LOGICAPP_READ', version: '7.5' },

    // Flowable
    FLOWABLE_REST: { value: 'FLOWABLE_REST', version: '7.4' },

    // Contract download
    CONTRACT_DOWNLOAD: { value: 'CONTRACT_DOWNLOAD', version: 'legacy' }
};
